import { render, staticRenderFns } from "./ThirdRow.vue?vue&type=template&id=1f608714&scoped=true"
import script from "./ThirdRow.vue?vue&type=script&lang=js"
export * from "./ThirdRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f608714",
  null
  
)

export default component.exports